import { useLocation } from "react-router-dom";
import { useEffect, useLayoutEffect } from "react";

export default function ScrollToTop() {
    const { pathname, search, hash } = useLocation();

    // Disable browser's scroll restoration (prevents opening mid-page)
    useEffect(() => {
        if ("scrollRestoration" in window.history) {
            const prev = window.history.scrollRestoration;
            window.history.scrollRestoration = "manual";
            return () => { window.history.scrollRestoration = prev; };
        }
    }, []);

    // On route change, scroll to hash if present; otherwise to top
    useLayoutEffect(() => {
        if (hash) {
            const el = document.querySelector(hash);
            if (el) {
                el.scrollIntoView({ block: "start" });
                return;
            }
        }
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname, search, hash]);

    return null;
}
